import React from 'react'
import { Box, Typography } from '@mui/material'
import Inventory2Icon from '@mui/icons-material/Inventory2'
import LocalShippingIcon from '@mui/icons-material/LocalShipping'
import WarehouseIcon from '@mui/icons-material/Warehouse'
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox'
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn'
import PeopleAltIcon from '@mui/icons-material/PeopleAlt'

const iconMap = {
  Inventory2: Inventory2Icon,
  LocalShipping: LocalShippingIcon,
  Warehouse: WarehouseIcon,
  MoveToInbox: MoveToInboxIcon,
  AssignmentTurnedIn: AssignmentTurnedInIcon,
  PeopleAlt: PeopleAltIcon,
}

const SummaryCards = ({ cards = [] }) => {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        gap: 1.5,
        p: 1.5,
        mt: 1,
        mb: 1,
        border: '1px solid #6d6d6d',
        borderRadius: '6px',
        backgroundColor: '#fff',
      }}
    >
      {cards.map((card) => {
        const Icon = iconMap[card.icon] || Inventory2Icon

        return (
          <Box
            key={card.key}
            sx={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: 1,
              flex: '1 1 140px',
              minWidth: 140,
              minHeight: 72,
              px: 1.25,
              py: 1.75,
              borderRadius: '6px',
              backgroundColor: '#fff',
              boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
              border: '1px solid #eee',
            }}
          >
            <Box
              sx={{
                width: 40,
                height: 40,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '8px',
                backgroundColor: `${card.color}18`,
                color: card.color,
                flexShrink: 0,
                mt: 0.25,
              }}
            >
              <Icon sx={{ fontSize: 24 }} />
            </Box>

            <Box sx={{ minWidth: 0 }}>
              <Typography
                sx={{
                  fontSize: 12,
                  fontWeight: 700,
                  color: '#555',
                  lineHeight: 1.25,
                  minHeight: card.subtitle ? 'auto' : '2.5em',
                  maxWidth: card.subtitle ? 120 : 76,
                  whiteSpace: 'normal',
                  wordBreak: 'break-word',
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                }}
              >
                {card.title}
              </Typography>
              {card.subtitle && (
                <Typography
                  sx={{
                    fontSize: 10,
                    fontWeight: 600,
                    color: '#777',
                    lineHeight: 1.3,
                    whiteSpace: 'nowrap',
                    mt: 0.25,
                    mb: 0.25,
                  }}
                >
                  {card.subtitle}
                </Typography>
              )}
              <Typography
                sx={{
                  fontSize: typeof card.value === 'string' ? 17 : 22,
                  fontWeight: 700,
                  color: '#111',
                  lineHeight: 1.2,
                }}
              >
                {typeof card.value === 'string'
                  ? card.value
                  : Number(card.value ?? 0).toLocaleString()}
              </Typography>
            </Box>
          </Box>
        )
      })}
    </Box>
  )
}

export default SummaryCards
